import { useDispatch, useSelector } from 'react-redux';
import { useCompareUrlWithProjectId } from './route';
import { REPORTS_ROUTES } from 'routes/routes.const';
import { RootState } from 'common/store';
import {
  applyCommonFilter,
  removeCommonFilter,
  selectAppliedFilters,
  updateCommonFilter,
} from 'common/store/slices/common-filters.slice';
import { DATASET_INITIAL_ID } from 'common/constants';
import { useCallback } from 'react';

interface OnFilterClickArgs {
  filterType: any;
  filterKey: any;
  filterLabel: string;
  value: [{ name: string; value: string | number }];
}

interface UseFilterClickArgs {
  datasetId?: string;
}

function useFilterClick({ datasetId }: UseFilterClickArgs = {}) {
  const dispatch = useDispatch();
  const { compareUrl } = useCompareUrlWithProjectId();
  const isReportsPage = compareUrl(REPORTS_ROUTES.root, { includes: true });
  const reduxFilters = useSelector((state: RootState) =>
    selectAppliedFilters(state, datasetId ?? DATASET_INITIAL_ID)
  );

  const onFilterClick = useCallback(
    ({ filterType, filterKey, filterLabel, value }: OnFilterClickArgs) => {
      if (isReportsPage) {
        return;
      }

      const updateFilter = ({
        filterValue,
      }: {
        filterValue: [{ name: string; value: string | number }];
      }) => {
        dispatch(
          updateCommonFilter({
            filter: {
              type: filterType,
              key: filterKey,
              label: filterLabel,
              filter: {
                type: filterType,
                label: filterLabel,
                value: filterValue,
              },
            },
            datasetId: DATASET_INITIAL_ID,
          })
        );
      };
      if (reduxFilters[filterKey]) {
        const remainingFilterValue = reduxFilters[filterKey]?.value.filter(
          (v: { name: string }) => v.name !== value[0].name
        );
        if (!remainingFilterValue.length) {
          dispatch(removeCommonFilter({ datasetId: DATASET_INITIAL_ID, filterKey }));
        } else {
          updateFilter({ filterValue: remainingFilterValue });
        }
      } else {
        updateFilter({ filterValue: value });
      }
      dispatch(applyCommonFilter({ datasetId: DATASET_INITIAL_ID }));
    },
    [dispatch, isReportsPage, reduxFilters]
  );

  return onFilterClick;
}

export default useFilterClick;
